<style scoped>
.dropdown-divider {
    border-top-color: #000000;
}
</style>
<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from './list/setup'
import Transaction from './list/transaction'
import UpdateApplicationModal from './modals/update_application'
import PaymentHistoryModal from './modals/payment_history'
import tableMixin from '@/helpers/mixins/table' 
import { notify } from '@/helpers/notify' 
import Ability from '@/helpers/mixins/ability'
import CreatePaymentModal from './modals/create_payment'

export default {  
    page: {
      title: "Kurulum Bekleyenler",
    },
    components: {
      Layout,
      PageHeader,
      CreateSetup,
      Transaction,
      UpdateApplicationModal,
      PaymentHistoryModal,
      CreatePaymentModal
    }, 
    mixins: [tableMixin,Ability],
    data() {
     return {
        title: "KURULUM BEKLEYENLER",
        items: [
            { text: "ANASAYFA", href: "/" },
            { text: "KURULUM BEKLEYENLER", active: true }
        ],
        url: "/listeler/kurulum-bekleyenler",
        buttons:[
            { title:"Ön Başvuruyu Düzenle", icon:'bx bx-edit', func:this.edit, name:'duzenle', key:'duzenle', abilities:'admin|dealer'},
            { title:"Sil", icon:'bx bx-trash', func:this.silModel, name:'sil', key:'sil', abilities:'admin'},
        ],  
        columns: 
          [
            {
              field: '#',
              sortable: false,
              thClass: 'width-50',
            }, 
            {
              label: 'Kullanıcı Adı',
              field: 'username',
              sortable: false,
            },
            {
              label: 'İsim Soyisim',
              field: "fullname",
            },
            {
              label: 'Kayıt Tarihi',
              field: this.created_at,
            },
            {
              label: 'Randevu Tarihi',
              field:  this.appointment,
              html: true,
              sortable: false,
            },
            {
              label: 'Cep Telefonu',
              field: this.phonenumber,
              html: true,
              sortable: false,
            },
            {
              label: 'Whatsapp',
              field: this.whatsapp,
              html: true,
              sortable: false,
            },
            {
              label: 'İl',
              field: "province",
              sortable: false,
            }, 
            {
              label: 'Bölge',
              field:  "township",
              sortable: false,
            },
            {
              label: 'Adres',
              field:  "address",
              sortable: false,
            },
            {
              label: 'Bayisi',
              field: 'belong_name',
              sortable: false,
            },
            {
              label: 'Servis',
              field: 'tariff_name',
              sortable: false,
            },
            {
              label: 'Personel',
              field:  "user_name",
              sortable: false,
            }, 
          ],
        transactionData: {},
        data: {},
        detailSearch: false,
        kurulumRandevusu: true,
        trIndex: 0,
        currentRow: {},
        form: {},
        searchBox: {},
        updateSubsId: null,
        paymentHistoryData: {},
        modelOpen: 0,
        tekrarRandevuOpen: 0,
        showSubMenu: false,
        deleteSubsId:0
      };
    },
    computed: {
      ...mapGetters('authfack',['userdata'])
      
    },
    mounted(){
      document.getElementById('vgt-table').style.marginBottom = '150px'
      if(this.userdata.currentUser.role_name == 'admin' || this.userdata.currentUser.role_name == 'personel'){
        this.buttons.unshift({ title:"Randevu Ver", icon:'bx bx-calendar-event', func:this.randevuVer , key:'randevu'})
      }
      if(this.userdata.currentUser.role_name == 'admin'){
        this.buttons.unshift({ title:"İşleme Al", icon:'check', func:this.islemeAl , key:'islemeal'})
      }
    },
    methods: {
      islemeAl(obj){
        this.$http.post('/members/isleme-al', {  subs_id:obj.subs_id, type_id: 1 })
            .then(response => {
                if(response.data.code == 100){
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
      },

      appointment(obj){
          if(obj.appointment_at){
              if(obj.postpone){
              return  "<span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span> " +  (obj.hasOwnProperty('histories') && obj.histories.length > 0 ? obj.histories[0].description : '');
              }
              return this.formatDate(obj.appointment_at, 'DD.MM.YYYY HH') + ':00'  
          }
          return  '-'
      },
      created_at(obj){
        return this.formatDate(obj.created_at, "DD.MM.YYYY HH:mm")
      },
      phonenumber(obj){
        const url =   obj.phonenumber;
        return `<a href=tel:'${url}'  >${obj.phonenumber}</a>`
      },
      whatsapp(obj){
        const tel = obj.phonenumber2 ? obj.phonenumber2 : (obj.phonenumber ? obj.phonenumber : '-') 
        const url =  "https://wa.me/" + tel;
        return `<a target="_blank" href='${url}'  >${tel}</a>`
      },
      ok(obj){
        return obj.approval == null ? "<button class='btn btn-outline-info btn-sm'>Onay</button>" : obj.approval
      },
      installed(obj){
        return obj.installed || '<i class="text-danger fa fa-minus"></i>'
      },
      formSubmit(){
        this.updateParams({columnFilters : {...this.form}});
        //this.loadItems()
      },

      createSetup(prop){
        this.data = { type:1, subs_id :prop.subs_id }
        this.$parent.$bvModal.show('setup')
      },

      randevuVer(props){
        this.modelOpen += 1
        this.createSetup(props)
      },

      edit(props){
        this.updateSubsId = props.subs_id
        this.$parent.$bvModal.show('update_application_modal')
      },

      paymentHistory({username, subs_id}){
        this.paymentHistoryData = { id:subs_id, username}
        this.$parent.$bvModal.show('payment_history_modal')
      },

      createPayment(props){
        this.$store.dispatch('userDetail/setUserDetail', { id:props.subs_id, component:'onodeme', paymnet_type:'' });
        this.$bvModal.show('create_payment_modal')
      },

      showContextMenu(e) {
        var target = e.target;
    
        const menu = document.getElementById('menu');
        const ele = document.getElementById('vgt-table'); 

        ele.style.marginBottom = '155px'

        if (target.tagName === "TD" || target.tagName === "SPAN" ) {
          
          if (target.tagName === "SPAN") {
            var row = target.parentElement.parentElement;
            var rowIndex = row.rowIndex;
          
          } else {
            row = target.parentElement;
            rowIndex = row.rowIndex;
          }
      
        
          var thead = ele.querySelector("thead");
          var trElements = thead.querySelectorAll("tr");
          var trCount = trElements.length;
        
          this.trIndex = rowIndex - trCount
          
      
        } 
        e.preventDefault();

        const rect = ele.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Set the position for the menu
        menu.style.top = `${y}px`;
        menu.style.left = `${x}px`;

        this.currentRow = this.rows[this.trIndex]

        if(!this.currentRow.approval){
          this.kurulumRandevusu = false
        }else{
          this.kurulumRandevusu = true
        }
        menu.classList.remove('hidden');
        document.addEventListener('click', this.documentClickHandler);
      },

      documentClickHandler(e) {
        const menu = document.getElementById('menu');
          const isClickedOutside = !menu.contains(e.target);
          if (isClickedOutside) {
              menu.classList.add('hidden');
              document.removeEventListener('click', this.documentClickHandler);
          }
      },

      onayla(){
        this.$http.get('/members/'+ this.currentRow.id + '/onayla')
                    .then(resp => {
                        this.kurulumRandevusu = true
                        this.rows[this.trIndex]["approval"] = resp.data
                      })
      },

      silModel({ subs_id }){
        this.deleteSubsId = subs_id
        this.$parent.$bvModal.show('delete-scoped')
      },

      close(){
        this.$parent.$bvModal.hide('delete-scoped')
      },

      sil(){
        this.isLoading = true
        this.$http.delete('/members/'+ this.deleteSubsId)
        .then(() => {
          notify.success('Başarılı')
          this.close()
          this.loadItems()
        })
      },
      
      tekrarRandevuVer(prop){
        this.tekrarRandevuOpen += 1

        this.data = { type:1, id :prop.id }
        this.$parent.$bvModal.show('setup')
      },

      isRandevuVisible({ appointment_at }){
        const adminRole = this.userdata.currentUser.role_name == 'admin' || this.userdata.currentUser.role_name == 'personel'
        if(appointment_at && adminRole){
          return true;
        }
        return false;
      },

      appointmentVisible(name, prop){
        if(name == 'randevu' && prop.appointment_at){ // verildiyse randevu daha önce butonu sil
          return false
        }
     
        return true
      },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

    <CreateSetup  
      :data="modelOpen"
      :update="tekrarRandevuOpen"
      :type="data.type" 
      :subs_id="data.subs_id"
      :id="data.id"
      :randevu="true" 
      @loadItems="loadItems"
    />

    <Transaction 
      :transactionData="transactionData" 
      @loadItems="loadItems"  
    />

    <UpdateApplicationModal 
      :data="updateSubsId" 
    />

    <PaymentHistoryModal 
      :data="paymentHistoryData" 
    />

    <CreatePaymentModal />
    
    <b-modal id="delete-scoped" title="Kurulum Sil"  no-close-on-backdrop hide-footer>
        <form>
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label>Neden İptal Edildi</label>
                        <textarea class="form-control" v-model="form.name"></textarea>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <b-button variant="light" @click="close()">Vazgeç</b-button>
              <b-button 
                  type="button"
                  @click="sil" 
                  variant="success" 
                  class="ms-1"
                  >Onayla
              </b-button>
            </div>
        </form>
    </b-modal>

    <vue-good-table
        mode="remote"
        styleClass="vgt-table bordered condensed"
        :line-numbers="true" 
        :total-rows="totalRecords"
        :columns="columns"
        :rows="rows"
        :pagination-options="paginationOptions"
        :is-loading.sync="isLoading"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange">
        <template slot="loadingContent">
        <div>Yükleniyor</div>
        </template>
            <template
            slot="table-row"
            slot-scope="props"
            >
            <span
                v-if="props.column.field === '#'"
                class="text-nowrap"
            >
              <b-dropdown
                class="ms-2 "
                toggle-class="font-size-16 p-0"
                toggle-tag="a"
                variant="white"
                right
              >   
                  <b-dropdown-item 
                    v-if="ability('admin|personel')"
                    @click="createPayment(props.row)">
                    <i class="bx" :class="`bx-credit-card`"></i> Ödeme Al
                  </b-dropdown-item>
                    <b-dropdown-item 
                    v-if="ability('dealer')"
                    @click="createPayment(props.row)">
                    <i class="bx" :class="`bx-credit-card`"></i> Taksit Ödemesi Al 
                  </b-dropdown-item>
                  <b-dropdown-item 
                   v-if="ability('admin|personel')"
                    @click="paymentHistory(props.row)">
                    <i class="bx" :class="`bx-credit-card`"></i> Ödeme Geçmişi
                  </b-dropdown-item>

                  <b-dropdown-divider v-if="ability('admin|personel')"></b-dropdown-divider>
                  <b-dropdown-item 
                    v-if="isRandevuVisible(props.row)"
                    @click="tekrarRandevuVer(props.row)">
                    <i class="bx" :class="`bx-calendar-event`"></i> Tekrar Randevu Ver
                  </b-dropdown-item>
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <template   
                  v-for="(button,i) in buttons" >
                  <b-dropdown-item 
                    :key="i" 
                    v-if="appointmentVisible(button.key,props.row) && ability(button.abilities)"
                    @click="button.func(props.row)">
                    <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
                  </b-dropdown-item>
                  </template>
              </b-dropdown>
            </span>
        </template>
    </vue-good-table>
  </Layout>
</template>
